import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class Errors {

    errorCode = {

    };

    getErrorMessage(key: any) {
        var errorCodes: any = this.errorCode;
        var swap = Object.keys(errorCodes).reduce(function (obj: any, key: any) {
            obj[errorCodes[key]] = key;
            return obj;
        }, {});
        return swap[key];
    }
}
